import { FunctionComponent } from "react";

import { SuppressedTable } from "../components/SuppressedTable";

/** The Suppressed tab of Do-not-contact (PREC-4266); the page header is DoNotContact's. */
export const SuppressedView: FunctionComponent = () => (
	<div className="w-full">
		<SuppressedTable />
	</div>
);
